import fs from 'fs/promises';

export async function readAllLines(filePath: string): Promise<string[]> {
  const content = await fs.readFile(filePath, 'utf8');
  // Preserve newlines; split keeping consistency
  return content.split(/\r?\n/);
}


